<template>
    <header class="header-unlogged" :class="{'header-unlogged--collapsed': isCollapsed}">
        <NavbarTop class="header-unlogged__topnav" />
        <Navbar />
    </header>
</template>
<script setup lang="ts">
    import {ref, onMounted, onBeforeUnmount} from 'vue';
    import Navbar from './Navbar.vue';
    import NavbarTop from './NavbarTop.vue';
    import {useHeaderUnloggedScroll} from '../composables/useHeaderUnloggedScroll';

    /*
        Expected behavior:

        - while on "homepage" for unlogged user:
          - switch beteween /poc/ (client) and /poc/freelancer (freelancer)
          - set the navbar mode to "client" or "freelancer" accordingly

        - while on any other page
          - do not switch? but if we stay on the same page we need to ensure this page is available for the new mode (example dashboard freelancer is not available for client)

        - what about logged user?

    */

    const {isCollapsed} = useHeaderUnloggedScroll();

    const resizeTimer = ref<ReturnType<typeof setTimeout> | undefined>(undefined);
    function onResize() {
        document.querySelector('header')?.classList.add('resize-animation-stopper');
        clearTimeout(resizeTimer.value);
        resizeTimer.value = setTimeout(() => {
            document.querySelector('header')?.classList.remove('resize-animation-stopper');
        }, 400);
    }

    onMounted(() => {
        window.addEventListener('resize', onResize);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', onResize);
    });
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .resize-animation-stopper * {
        transition: none !important;
    }

    .header-unlogged {
        --navbar-transition-duration: 0.6s;
        --navbar-transition-easing: cubic-bezier(0.4, 0, 0.2, 1);
        --topnav-height: 0px;
        --navbar-height: 60px;
        position: sticky;
        top: 0;
        z-index: 1000;
        background-color: var(--joy-color-neutral-0);
        padding: 0 var(--joy-core-spacing-6);
        width: 100%;
        transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        transform: translateY(0);
        font-size: var(--joy-font-size-primary-300);

        &--collapsed {
            transform: translateY(calc(-1 * var(--topnav-height)));
        }
    }

    /* desktop */
    @include mq.screen_sm(min) {
        .header-unlogged {
            --topnav-height: 50px;
            padding: 0 var(--joy-core-spacing-7);
            border-bottom: 1px solid var(--joy-color-neutral-30);
        }
    }
</style>
